import progress from './progress/index.js';
import goalSetting from './goal-setting/index.js';
import {redirectIfBehaviourModulesAreNotEnabled} from "../../../../../hooks/enabled-module-guard";
import PatientOverviewStress from 'dashboard/templates/views/Patient/Stress/PatientOverviewStress';

const navigationSteps = {
  prevDiscussionStep: {
    PatientRecordStressProgress: 'PatientRecordProgress',
    PatientRecordStressGoalSetting: 'PatientRecordStressProgress',
  },
  nextDiscussionStep: {
    PatientRecordStressProgress: 'PatientRecordStressGoalSetting',
    PatientRecordStressGoalSetting: 'PatientRecordProgress',
  },
}

export default {
  component: PatientOverviewStress,
  path: 'stress-relief',
  name: 'PatientRecordStress',
  props: navigationSteps,
  redirect: { name: 'PatientRecordStressProgress' },
  meta: {
    // title: 'Patient Record Stress Relief',
    title: t => `${t('patient.patientRecord')} - ${t('stressReliefLevel3.dailyPresence.beneficialMindfulness.task1.stressRelief', 'content')}`,
    loggedInOnly: true,
  },
  children: [
    progress,
    goalSetting,
  ],
  async beforeEnter(to, from, next) {
    // If user was redirected from page because Stress management is not enabled, don't do anything.
    if (await redirectIfBehaviourModulesAreNotEnabled(["STRESSMANAGEMENT"], to, next)){
      return
    }

    next();
  },
};
